<template>
  <div class="mobile-examsence">
    <div class="title">适用多样化的考试场景</div>
    <div class="banner-txt">
      <div class="position1 position">
        <div class="diamond">
          <div class="wrap-info"><i class="iconfont iconkaoshi1"></i></div>
          <div class="text">批量校招考试</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">批量校招考试</div>
              <span class="inner-text">
                全球海量考生统考<br />
                招聘会现场手机考<br />
                快速淘劣</span
              >
            </div>
          </div>
        </div>
        <div class="diamond">
          <div class="wrap-info"><i class="iconfont icongongsi"></i></div>
          <div class="text">企业社招考试</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">企业社招考试</div>
              <span class="inner-text"
                >候选人等候面试时手机考试 面试官可多维度考核</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="position2 position">
        <div class="diamond">
          <div class="wrap-info">
            <i class="iconfont iconjinshengguanli"></i>
          </div>
          <div class="text">员工晋升考核</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">员工晋升考核</div>
              <span class="inner-text">
                内部员工晋升<br />
                胜任力达标能力测试、素质测评</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="position3 position">
        <div class="diamond">
          <div class="wrap-info">
            <i class="iconfont iconjinshengkaohe"></i>
          </div>
          <div class="text">培训认证考核</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">培训认证考核</div>
              <span class="inner-text">
                培训机构结业认证<br />考核<span v-if="isMobile">，</span
                ><span v-if="!isMobile"> <br /></span>行业从业资格认证考核</span
              >
            </div>
          </div>
        </div>
        <div class="diamond">
          <div class="wrap-info">
            <i class="iconfont iconjingsaiguanli2"></i>
          </div>
          <div class="text">专业知识竞赛</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">专业知识竞赛</div>
              <span class="inner-text">
                提供专业知识<br />竞赛平台<span v-if="isMobile">、</span
                ><span v-if="!isMobile"> <br /></span>
                报名、组队、闯关赛等</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="position4 position">
        <div class="diamond">
          <div class="wrap-info"><i class="iconfont iconlianxi"></i></div>
          <div class="text">随堂练习检测</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">随堂练习检测</div>
              <span class="inner-text"
                >学生随堂参加测试<br />
                考后查看题目解析<br />
                提升能力</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="position5 position">
        <div class="diamond ipadDiamond-left">
          <div class="wrap-info"><i class="iconfont iconchengji"></i></div>
          <div class="text">高校招生测评</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">高校招生测评</div>
              <span class="inner-text">
                学校招生统一专业<br />能力考试<span v-if="!isMobile">
                  <br /></span
                ><span v-if="isMobile">，</span> 远程视频面试选拔</span
              >
            </div>
          </div>
        </div>
        <div class="ipadDiamond"></div>
        <div class="diamond">
          <div class="wrap-info"><i class="iconfont icontiku"></i></div>
          <div class="text">海量题库刷题</div>
          <div class="diamond-inner">
            <div class="reverse-text">
              <div class="inner-title">海量题库刷题</div>
              <span class="inner-text"
                >学员按知识点分类<br />刷题，随机抽题，<br />进阶学习</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
  },
}
</script>
<style lang="scss" scoped>
.mobile-examsence {
  text-align: center;
  .title {
    font-size: 28px;
    font-weight: 300;
    padding: 24px 0 0 0;
    text-align: center;
  }
}
.banner-txt {
  color: #333;
  width: 330px;
  position: relative;
  margin: 30px auto;
  margin-bottom: 0;
  text-align: center;
  left: 2rem;
  .position {
    display: flex;
    &.position1 {
      position: absolute;
      top: 0rem;
    }
    &.position2 {
      position: absolute;
      top: 5rem;
      left: 4.3rem;
    }
    &.position3 {
      position: absolute;
      top: 10rem;
    }
    &.position4 {
      position: absolute;
      top: 15rem;
      left: 4.3rem;
    }
    &.position5 {
      position: absolute;
      top: 20rem;
    }
  }
  .diamond {
    width: 8rem;
    height: 8rem;
    background: url('~@/static/images/fangkuai-t.png');
    position: relative;
    cursor: pointer;
    background-size: cover;
    margin-right: 0.5rem;
    .wrap-info {
      position: absolute;
      top: 2rem;
      left: 3rem;
      text-align: center;
      .iconfont {
        font-size: 2rem;
        color: #29bdb9;
      }
    }
    .text {
      position: absolute;
      top: 4.8rem;
      font-size: 0.7rem;
      font-weight: 400;
      text-align: center;
      width: 100%;
    }
    .white-circle {
      width: 1rem;
      height: 1rem;
      background: #fff;
      border-radius: 0.83333rem;
      margin: 9.83333rem auto 0 9.58333rem;
    }
    .diamond-inner {
      display: none;
      transform: rotate(-45deg);
    }
    .reverse-text {
      text-align: center;
      display: none;
      color: #fff;
      transform: rotate(45deg);
      .inner-title {
        padding: 0px 0px 10px;
      }
    }
    &:hover {
      cursor: pointer;
      img {
        display: none;
      }
      .diamond-inner {
        width: 5.7rem;
        height: 5.7rem;
        margin-top: 1rem;
        margin-left: 1.2rem;
        position: absolute;
        background: #29bdb9;
        font-size: 14px;
        display: block;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        z-index: 99;
      }
      .reverse-text {
        display: block;
        z-index: 50;
        font-size: 0.6rem;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .mobile-examsence {
    .position {
      &.position5 {
        top: 5rem;
        .ipadDiamond {
          width: 10rem;
        }
        .ipadDiamond-left {
          margin-left: -5rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/examsence/mobile.vue